import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import BaseUrl from "../URL";
import i18n from "../i18n/i18n";
import { UpdateCreateAgenda } from "../redux/actions/CreateAgendaAction";
import {
  DeleteEvent,
  DeleteLocation,
  DidAddAbsence,
  UpdateAgenda,
  UpdateCategory,
  UpdateEvent,
  UpdateLocation,
  UpdateLocationAgenda,
  UpdateService,
  UpdateSpecialty
} from "../redux/actions/ListActions";
import { GetCurrentUserTypeInt, GetLoggedUserUUID, GetMediCenterId, GetOwnerOfLoggedMcUUID, GetReferenceKey, objectToFormData, UserList } from "../utils/constants";
import { UpdateConfigSettings } from "../redux/actions/SettingsConfigAction";
import { usePopUpHook } from "../utils/Popup/PopupContext";
import { Button } from "react-bootstrap";
import { updateHolidayEvent } from "../redux/actions/HolidayEventAction";
import { FileViewer, GlobalLoaderActivate } from "../utils/commonFunctions";

const PostHeaders = {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "X-UHC-NUMBER": GetMediCenterId(),
  },
  'credentials': 'omit'
};

const PostHeadersMulti = {
  method: "POST",
  headers: {
    "Content-Type": "multi-part/formdata",
    Authorization: "Bearer my-token"
  }
};

const GetHeaders = {
  method: "GET",
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "X-UHC-NUMBER": GetMediCenterId(),
  },
  'credentials': 'omit'
};

export const AppFetch = async (url, requestBody) => {
  requestBody?.headers ? requestBody.headers.Authorization = `Bearer ${GetReferenceKey()}` : requestBody.headers = { Authorization: `Bearer ${GetReferenceKey()}` }
  if (requestBody?.method == "POST") {
    const csrf = document.head.querySelector('meta[name="csrf-token"]')?.content || 'h7cZLvXG8XiTsLKZaQIaIoroowxoEPAlFi31F7vn'
    if (requestBody?.body instanceof FormData) {
      requestBody?.body.append('_token', csrf)
    } else {
      const tokenedBody = requestBody?.body ? JSON.parse(requestBody?.body) : {}
      requestBody.body = JSON.stringify({
        ...tokenedBody,
        _token: csrf
      })
    }
  }
  requestBody.credentials = 'omit'
  return fetch(url, requestBody)
}

export const showError = (error, sendDefaultMessage = true, config) => {
  toast.error(
    i18n.t(sendDefaultMessage ? 'failure' : error)
    , {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      bodyStyle: { 'fontSize': '14px' },
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      ...config
    });
};
export const showSuccess = message => {
  toast.success(
    // message.charAt(0).toUpperCase() + message.slice(1)
    i18n.t('success')
    , {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      bodyStyle: { 'fontSize': '14px' },
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light"
    });
};

export const OpeningData = (fromDate, toDate, medical_center_id, agenda_id, repeat) => {
  var data;
  const params = new URLSearchParams({
    from_date: fromDate,
    to_date: toDate,
    // doctor_id: GetLoggedUserId()
    medical_center_id,
    agenda_id: agenda_id
  })

  data = AppFetch(`${BaseUrl.endpoint}/opening/list?${params}`, { ...GetHeaders }).then(response => response.json()).then(data => {
    return data;
  });

  return data;
};


export const useAppointmentData = ({
  getInitial = false,
  resBody = undefined,
  preventRedux = false
}) => {
  const selector = useSelector(state => state.lists.eventList);
  const [data, setData] = useState(null)
  const dispatch = useDispatch();
  const [body, setBody] = useState(resBody);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);

  const get = useCallback(body => {
    body && setBody(body);
    setTimeout(() => setMakeCall(true), 10)
  }, []);


  useEffect(
    () => {
      if (makeCall) {
        setMakeCall(false);
        setData(null)
        setLoader(true);
        AppFetch(
          `${BaseUrl.endpoint}/appointment/list${body}${GetCurrentUserTypeInt() == UserList.medecin ? `&medical_center_id=${GetMediCenterId()}` : ''}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(responseData => {
            if (responseData) {
              !preventRedux && dispatch(UpdateEvent([...new Map(responseData.data.map(obj => [obj.id, obj])).values()]));
              setData([...new Map(responseData.data.map(obj => [obj.id, obj])).values()])
              return;
            }
            throw responseData;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data: preventRedux ? data : selector, error, loader, get, body };
};


// export const useConsultationList = ({ getInitial = false }) => {
//   const [data, setData] = useState(null);
//   const [error, setError] = useState(null);
//   const [loader, setLoader] = useState(false);
//   const [makeCall, setMakeCall] = useState(getInitial);
//   const get = () => {
//     setMakeCall(true);
//   };
//   useEffect(
//     () => {
//       if (makeCall) {
//         setLoader(true);
//         AppFetch(`${BaseUrl.endpoint}/appointment/list`, {
//           ...GetHeaders
//         })
//           .then(res => res.json())
//           .then(data => {
//             if (data && data.code == 200) {
//               setData([...new Map(data.map(obj => [obj.id, obj])).values()]);
//             }
//             throw data;
//           })
//           .catch(setError)
//           .finally(() => {
//             setMakeCall(false);
//             setLoader(false);
//           });
//       }
//     },
//     [makeCall]
//   );

//   return { data, error, loader, get };
// };

export const useCategoryList = (
  { getInitial = false, resBody = {}, cache = false },
  showPrevious = true,
) => {
  const selector = useSelector(state => state.lists);
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [body, setBody] = useState(resBody);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);
  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams(JSON.parse(JSON.stringify({ doctor_id: GetLoggedUserUUID(), ...body })))
        AppFetch(`${BaseUrl.endpoint}/category/medical_center?${params}`, {
          ...GetHeaders
        })
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            showPrevious && dispatch(UpdateCategory(data.data));
            setData([...data.data]);
          })
          .catch(setError)
          .finally(() => {
            setMakeCall(false)
            setLoader(false);
          });
      }
    },
    [makeCall]
  );

  return {
    data: showPrevious ? selector.categoryList : data,
    error,
    loader,
    get
  };
};


export const useAdminCategoryList = (
  { getInitial = false, resBody = undefined, doctorId = undefined },
) => {
  const [data, setData] = useState(null);
  const [body, setBody] = useState(resBody);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);
  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);

        AppFetch(`${BaseUrl.endpoint}/category`, {
          ...GetHeaders
        })
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            setData(data.data);
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return {
    data: data,
    error,
    loader,
    get
  };
};


export const usePatientsList = ({
  getInitial = false,
  resBody = undefined
}) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall && body) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body, medical_center_id: GetMediCenterId() });
        AppFetch(`${BaseUrl.endpoint}/patient/search?${params}`, {
          ...GetHeaders
        })
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data && data.code == 200) {
              setData(data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const useServiceList = ({ getInitial = false, resBody = {}, cache = false }, showPrevious = true) => {
  const selector = useSelector(state => state.lists);
  const [data, setData] = useState(null);
  const dispatch = useDispatch();
  const [body, setBody] = useState(resBody);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    cache = true
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ doctor_id: GetLoggedUserUUID(), ...body })
        AppFetch(`${BaseUrl.endpoint}/service/medical_center/list?${params}`, {
          ...GetHeaders
        })
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            showPrevious && dispatch(UpdateService(data.data));
            setData([...data.data])
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data: showPrevious ? selector.consultationServiceList : data, error, loader, get };
};

export const useAdminServiceList = ({ getInitial = false, resBody = undefined, doctorId = undefined }) => {
  const [data, setData] = useState(null)
  const [body, setBody] = useState(resBody);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        AppFetch(`${BaseUrl.endpoint}/service/list`, {
          ...GetHeaders
        })
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            setData([...data.data])
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data: data, error, loader, get };
};

export const useAppointmentBooking = () => {
  const popup = usePopUpHook()
  const post = body =>
    new Promise(async (resolve, reject) => {
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/appointment/booking`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
          // medical_center_id: GetCurrentUserTypeInt() == UserList['medecin'] ? GetMediCenterId() : (GetMediCenterId() || '0')
        })
      });
      const res = await apiCall.json();
      if (apiCall.ok) {
        showSuccess(i18n.t("success_added"));
        resolve(res.data);
      } else {
        if (res?.data?.code == 1001) {
          if (GetCurrentUserTypeInt() == UserList['patient']) {
            popup.open(
              <div className='share-alert-popup'>
                <div className='share-alert-info'>{i18n.t('no_tele_yet_contact')}</div>
                <Button onClick={popup.hide} className='d-block' variant="outline-primary">{i18n.t('ok')}</Button>
              </div>,
              true,
              undefined,
              {
                backdrop: true,
                serviceAvailability: false
              }
            )
          } else {
            showError(i18n.t('zoom_user_does_not_exist', { user: res?.data?.doctor_email }), false)
          }
        } else if (res?.code == 1111) {
          popup.open(
            <div className='share-alert-popup'>
              <div className='share-alert-info'>{i18n.t('appointment_booking_is_not_available')}</div>
              <Button onClick={popup.hide} className='d-block' variant="outline-primary">{i18n.t('ok')}</Button>
            </div>,
            true,
            undefined,
            {
              backdrop: true,
              serviceAvailability: false
            }
          )
        } else if (res?.data?.[0]?.errcode == 400) {
          showError(res?.data?.[0].message, false);
        }
        else {
          showError(res.message, false);
        }
        reject(res);
      }
    });
  return { post };
};

export const useAppointmentShow = ({
  getInitial = false,
  resBody = undefined
}) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(
    body => {
      body && setBody(body);
      setMakeCall(true);
    },
    [setMakeCall]
  );
  useEffect(() => {
    if (makeCall) {
      setLoader(true);
      setMakeCall(false);
      AppFetch(`${BaseUrl.endpoint}/appointment/show/${body}`, {
        ...GetHeaders
      })
        .then(async res => {
          if (res.ok) {
            return res.json();
          }
          const error = await res.json();
          throw error;
        })
        .then(data => {
          if (data) {
            setData({ ...data.data });
          }
        })
        .catch(setError)
        .finally(() => {
          setLoader(false);
        });
    }
  },
    [makeCall, body, setData]
  );

  return { data, error, loader, get };
};

export const useAppointmentShowWithPromise = () => {
  const [loader, setLoader] = useState(false)
  const get = body => new Promise(async (resolve, reject) => {
    setLoader(true)
    const apiCall = await AppFetch(`${BaseUrl.endpoint}/appointment/show/${body}`, {
      ...GetHeaders
    })

    const res = await apiCall.json();
    if (apiCall.ok) {
      resolve(res.data)
      setLoader(false)
    } else {
      showError(res.message);
      reject(res);
      setLoader(false)
    }
  })

  return { get, loader }
}

export const usePatientInsert = () => {
  const post = body =>
    new Promise(async (resolve, reject) => {
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/patient/insert`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
          'api_post': '2',
          "medical_center_id": GetMediCenterId(),
          'logged_user_id': GetLoggedUserUUID(),
          'logged_user_type': GetCurrentUserTypeInt(),
          'owner_of_logged_mc_id': GetOwnerOfLoggedMcUUID(),
        })
      });
      const res = await apiCall.json();
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        if (res?.data?.[0]?.errcode != 2000 && res?.data?.[0]?.errcode != 1011) {
          showError(res?.data?.[0]?.message, (!res?.data?.[0]?.message));
        }
        reject(res);
      }
    });
  return { post };
};

export const useSpecialty = ({ getInitial = false }) => {
  const selector = useSelector(state => state.lists);
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(() => {
    setMakeCall(true);
  }, []);
  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);

        AppFetch(`${BaseUrl.endpoint}/specialite/list`, {
          ...GetHeaders
        })
          .then(async res => {
            const response = await res.json();
            if (res.ok) {
              return response;
            } else {
              throw response;
            }
          })
          .then(data => {
            dispatch(UpdateSpecialty(data.data));
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall]
  );

  return { data: selector.specialtyList, error, loader, get };
};

export const useAddCategory = ({ successShow = true }) => {
  const [loader, setLoader] = useState(false)
  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/category/insert`, {
        ...PostHeaders,
        body: JSON.stringify({ ...body, doctor_id: body.doctorId ? body.doctorId : GetLoggedUserUUID(), created_by: GetLoggedUserUUID() })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        successShow && showSuccess(i18n.t("success_added"));
        resolve(res.data);
      } else {
        reject(res);
      }
    });
  return { post, loader };
};

export const useInsertOpening = ({
  getInitial = false,
  resBody = undefined
}) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall && body) {
        setLoader(true);
        setMakeCall(false);

        AppFetch(`${BaseUrl.endpoint}/opening`, {
          ...PostHeaders,
          body: JSON.stringify({
            ...body,
            medical_center_id: GetMediCenterId()
          })
        })
          .then(res => res.json())
          .then(data => {
            if (data && data.code == 200) {
              setData(data);
              showSuccess(i18n.t("success_added"));
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

/**
 * 
 * @returns const apiCall = await AppFetch(`${URL.endpoint}/location/insert`, {
        // ...PostHeaders,
        method: 'POST',
        body: body instanceof FormData ? (() => {
          body.append('created_by', GetLoggedUserId())
          body.append('logged_user_id', GetLoggedUserId())
          return body
        })() : JSON.stringify({
          ...body,
          created_by: GetLoggedUserId(), logged_user_id: GetLoggedUserId()
        })
      });
      setLoa
 */

export const useAddService = () => {
  const [loader, setLoader] = useState(false)
  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/service/medical_center`, {
        // ...PostHeaders,
        method: 'POST',
        body: body instanceof FormData ? (() => {
          body.append('created_by', GetLoggedUserUUID())
          body.append('doctor_id', body.get('doctorId') ? body.get('doctorId') : GetLoggedUserUUID())
          return body
        })() : JSON.stringify({
          ...body,
          doctor_id: body.doctorId ? body.doctorId : GetLoggedUserUUID(),
          created_by: GetLoggedUserUUID()
        })
        // body: JSON.stringify({ ...body, doctor_id: body.doctorId ? body.doctorId : GetLoggedUserId(), created_by: GetLoggedUserId() })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        showSuccess(i18n.t("success_added"));
        resolve(res.data);
      } else {
        if (res.code == 400 && res.data?.some?.(val => val?.field == 'prescription_file' && val?.errcode == 2002)) {
          showError(i18n.t("please_upload_maximum_5_files"), false);
          return
        } else {
          showError(res.message)
          return
        }
      }
    });
  return { post, loader };
};

export const useUpdateService = () => {
  const [loader, setLoader] = useState(false)
  const post = (id, body) =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/service/edit/${id}`, {
        // ...PostHeaders,
        method: 'POST',
        body: body instanceof FormData ? (() => {
          body.append('created_by', GetLoggedUserUUID())
          body.append('doctor_id', body.get('doctorId') ? body.get('doctorId') : GetLoggedUserUUID())
          return body
        })() : JSON.stringify({
          ...body,
          created_by: GetLoggedUserUUID(),
          doctor_id: body.doctorId ? body.doctorId : GetLoggedUserUUID()
        })

        // body: JSON.stringify({ ...body, doctor_id: body.doctorId ? body.doctorId : GetLoggedUserId(), created_by: GetLoggedUserId() })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        showSuccess(i18n.t("success_modified"));
        resolve(res.data);
      } else {
        if (res.code == 400) {
          showError(i18n.t("please_upload_maximum_5_files"), false);
          return
        } else {
          showError(res.message)
        }
        reject(res);
      }
    });
  return { post, loader };
};

export const useDeleteCategory = () => {
  const selector = useSelector(state => state.lists.categoryList);
  const dispatch = useDispatch();
  const post = id =>
    new Promise(async (resolve, reject) => {
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/category/delete/${id}`, {
        ...PostHeaders
      });
      const res = await apiCall.json();
      if (apiCall.ok) {
        const temp = [...selector];
        temp.splice(temp.findIndex(value => value?.id == id), 1);
        dispatch(UpdateCategory(temp));
        resolve(res.data);
        showSuccess(res.message);
      } else {
        if (res?.code?.toString() == '409') {
          showError(i18n.t("api_err_category_cant_delete"), false);
        } else {
          showError(res.message)
        }
        resolve("");
      }
    });
  return { post };
};

export const useDeleteService = () => {
  const selector = useSelector(state => state.lists.consultationServiceList);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false)
  const post = id =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/service/delete/${id}`, {
        ...PostHeaders
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        const temp = [...selector];
        temp.splice(temp.findIndex(value => value?.id == id), 1);
        dispatch(UpdateService(temp));
        resolve(res.data);
        showSuccess(res.message);
      } else {
        if (res?.code?.toString() == '409') {
          showError(i18n.t("api_err_service_cant_delete"), false);
        } else {
          showError(res.message)
        }
        resolve("");
      }
    });
  return { post, loader };
};

export const useDeleteOpening = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const deleteOpening = (body) => {
    setLoader(true);
    AppFetch(`${BaseUrl.endpoint}/opening/delete/${body}`, {
      ...PostHeaders
    })
      .then(res => res.json())
      .then(data => {
        if (data && data.code == 200) {
          setData(data);
          setLoader(false);
          return;
        }
        throw data;
      })
      .catch(setError)
      .finally(() => {
        setLoader(false);
      });
  };

  return { data, error, loader, deleteOpening };
};

export const useEditOpening = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);

  const edit = (opening_id, body) => {
    setLoader(true);
    AppFetch(`${BaseUrl.endpoint}/opening/edit/${opening_id}`, {
      ...PostHeaders,
      body: JSON.stringify(body)
    })
      .then(res => res.json())
      .then(data => {
        if (data && data.code == 200) {
          setData(data);
          showSuccess(i18n.t("success_updated"));
          setLoader(false);
          return;
        }
        throw data;
      })
      .catch(setError)
      .finally(() => {
        setLoader(false);
      });
  };

  return { data, error, loader, edit };
};

export const useAppointmentStatus = () => {
  const [loader, setLoader] = useState(false)
  const post = (id, body) =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/appointment/status/${id}`, {
        ...PostHeaders,
        body: JSON.stringify({
          'created_by': GetLoggedUserUUID(),
          'confirme_by': GetLoggedUserUUID(),
          'action_by': GetCurrentUserTypeInt(),
          ...body
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
        showSuccess(res.message);
      } else {
        if (res?.code == 1) {
          showError(i18n.t('service_no_tele'), false)
        } else if (res?.data?.code == 1001) {
          showError(`Zoom - ${res?.data?.message || ''}`, false)
        } else if (res?.code == 2 && body?.action == 'RDV_CAN') {
          showError(i18n.t('apt_no_cancel_before'), false)
        } else {
          showError(res.message);
        }
        reject(res);
      }
    });
  return { post, loader };
};

export const useAppointmentMove = () => {
  const selector = useSelector(state => state.lists.eventList);
  const [loader, setLoader] = useState(false)
  const dispatch = useDispatch()

  const post = (id, body) =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/appointment/move/${id}`, {
        ...PostHeaders,
        body: JSON.stringify(body)
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        selector?.map?.((event) => {
          if (event?.id == id) {
            event.end_date = body.endDate
            event.start_date = body.startDate
            if (body.agenda_id && event.agenda_id) { event.agenda_id = body.agenda_id }
            // event.status = [...AppointmentStatus, ...OtherStatusViews].find(status => status.CODE == body.deplacer_action)?.code
          }
        })
        dispatch(UpdateEvent((selector || [])));
        resolve(res.data);
        showSuccess(res.message);
      } else {
        showError(res.data, false);
        reject(res);
      }
    });
  return { post, loader };
};

export const useAppointmentDelete = () => {
  const [loader, setLoader] = useState(false)
  const dispatch = useDispatch();
  const post = (id, body) =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/appointment/delete/${id}`, {
        ...PostHeaders,
        body: JSON.stringify({ ...body })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        dispatch(DeleteEvent(id));
        resolve(res.data);
        showSuccess(res.message);
      } else {
        if (res?.code == 1) {
          showError(i18n.t('confirmed_cannot_delete'), false)
        } else {
          showError(res.message)
        }
        reject(res);
      }
    });
  return { post, loader };
};
export const useSecretarySelect = () => {
  const post = (body) =>
    new Promise(async (resolve, reject) => {
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/secretary/select`, {
        ...PostHeaders,
        body: JSON.stringify(body)
      });
      const res = await apiCall.json();
      if (apiCall.ok) {
        resolve(res.data);
        showSuccess(res.message);
      } else {
        showError(res.message);
        reject(res);
      }
    });
  return { post };
};
export const useAppointmentUpdate = () => {
  const post = (id, body) =>
    new Promise(async (resolve, reject) => {
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/appointment/update/${id}`, {
        ...PostHeaders,
        body: JSON.stringify(body)
      });
      const res = await apiCall.json();
      if (apiCall.ok) {
        resolve(res.data);
        showSuccess(res.message);
      } else {
        if (res?.data?.code == 1001) {
          showError(i18n.t('zoom_user_does_not_exist', { user: res?.data?.doctor_email }), false)
        } else {
          showError(res.message, false);
        }
        reject(res);
      }
    });
  return { post };
};

export const useAppointmentAvailability = ({
  getInitial = false,
  resBody = undefined,
}) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall && body) {
        setLoader(true);
        setMakeCall(false);

        AppFetch(
          `${BaseUrl.endpoint}/appointment/availability${body}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data && data.code == 200) {
              setError(null);
              setData(data);
              return;
            }
            throw data;
          })
          .catch(error => {
            setData(null);
            setError(error);
          })
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const useCheckWarning = ({
  getInitial = false,
  reqParams = undefined
}) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (reqParams && getInitial === true) {
      get(reqParams);
    }
  }, []);

  const get = reqParams => {
    setLoader(true)
    if (reqParams) {
      AppFetch(`${BaseUrl.endpoint}/doctor/availablity${reqParams}`, {
        ...GetHeaders
      })
        .then(async res => {
          if (res.ok) {
            return res.json();
          }
          const error = await res.json();
          throw error;
        })
        .then(data => {
          setLoader(false)
          if (data) {
            setData(data.data);
            return;
          }
          throw data;
        })
        .catch(setError)
        .finally(() => {
          setLoader(false);
        });
    }
  };

  return { data, error, loader, get };
};

export const usePatientUpdate = () => {
  const post = (id, body) =>
    new Promise(async (resolve, reject) => {
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/patient/update/${id}`, {
        ...PostHeaders,
        body: JSON.stringify(body)
      });
      const res = await apiCall.json();
      if (apiCall.ok) {
        resolve(res.data);
        showSuccess(res.message);
      } else {
        showError(res.message);
        reject(res);
      }
    });
  return { post };
};

export const useAttachToAppointment = () => {
  const [loader, setLoader] = useState(false)
  const post = formData =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/rdv-document`, {
        method: "POST",
        body: formData
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
        showSuccess(res.message);
      } else {
        const fileSizeErr = res.message == 'FILE_SIZE_EXCEEDED.' ? true : false
        showError(fileSizeErr ? i18n.t('files_may_not_be_greater_than_10_MB') : res.message, !(fileSizeErr));
        reject(res);
      }
    });
  return { post, loader };
};

export const useDoctorSearchList = ({
  getInitial = false,
  resBody = undefined
}) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall && body) {
        setLoader(true);
        setMakeCall(false);

        AppFetch(`${BaseUrl.endpoint}/doctor/search${body}`, {
          ...GetHeaders
        })
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data && data.code == 200) {
              setData(data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get }
}

export const useSecretaryList = ({
  getInitial = false,
  resBody = undefined
}) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        AppFetch(`${BaseUrl.endpoint}/secretary/list?medical_center_id=${GetMediCenterId()}`, {
          ...GetHeaders
        })
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data && data.code == 200) {
              setData(data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get }
}

export const useOpeningTimesList = ({ getInitial = false, resBody = undefined }) => {
  const [body, setBody] = useState(resBody)
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const [loader, setLoader] = useState(false)
  const [makeCall, setMakeCall] = useState(getInitial)
  const get = useCallback((body) => {
    body && setBody(body)
    setMakeCall(true)
  }, [])

  useEffect(() => {
    if (makeCall && body) {
      setLoader(true)
      setMakeCall(false)
      const queryParams = new URLSearchParams({ ...body });
      AppFetch(`${BaseUrl.endpoint}/opening/times?${queryParams}`, {
        ...GetHeaders,
      }).then(async res => {
        if (res.ok) {
          return res.json()
        }
        const error = await res.json()
        throw error
      }).then(data => {
        if (data && data.code == 200) {
          setData(data.data)
          return
        }
        throw data
      })
        .catch(setError)
        .finally(() => {
          setLoader(false)
        })
    }
  }, [makeCall, body])

  return { data, error, body, loader, get }
}

export const useZoomMeetInfo = () => {
  const [body, setBody] = useState()
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const [loader, setLoader] = useState(false)
  const [makeCall, setMakeCall] = useState()
  const get = useCallback((body) => {
    body && setBody(body)
    setMakeCall(true)
  }, [])

  useEffect(() => {
    if (makeCall && body) {
      setLoader(true)
      setMakeCall(false)

      AppFetch(`${BaseUrl.endpoint}/meeting/info${body}`, {
        ...GetHeaders,
      }).then(async res => {
        if (res.ok) {
          return res.json()
        }
        const error = await res.json()
        throw error
      }).then(data => {
        if (data && data.code == 200) {
          setData(data.data)
          return
        }
        throw data
      }).catch(setError).finally(() => {
        setLoader(false)
      })
    }
  }, [makeCall, body])
  return { data, error, loader, get }
}

export const useAgendaInsert = () => {
  const popup = usePopUpHook()
  const post = body =>
    new Promise(async (resolve, reject) => {
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/agenda/insert`, {
        ...PostHeaders,
        body: JSON.stringify({ created_by: GetLoggedUserUUID(), ...body })
      });
      const res = await apiCall.json();
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        // reject(res);
        if (res.code == 409) {
          popup.open(
            <div className='share-alert-popup'>
              <div className='share-alert-info'>{res.message}</div>
              <Button onClick={() => popup.hide()} className='d-block' variant="outline-primary">{i18n.t('ok')}</Button>
            </div>,
            true,
            undefined,
            {
              backdrop: true,
              serviceAvailability: false
            }
          )
          resolve()
        }
        else {
          showError(res.message, false);
        }
      }
    });
  return { post };
};


export const useAccessibilityList = ({ getInitial = false, resBody = {} }) => {
  const selector = useSelector(state => state.lists.locationList);
  const dispatch = useDispatch()
  const [body, setBody] = useState(resBody)
  const [error, setError] = useState(null)
  const [loader, setLoader] = useState(false)
  const [makeCall, setMakeCall] = useState(getInitial)
  const get = useCallback((innerBody) => {
    innerBody && setBody(innerBody)
    !makeCall && setMakeCall(true)
  }, [makeCall])
  useEffect(() => {
    if (makeCall) {
      setMakeCall(false)
      setLoader(true)
      const queryParams = new URLSearchParams({ "logged_user_id": GetLoggedUserUUID(), ...resBody });
      AppFetch(`${BaseUrl.endpoint}/accessible/locations/list?${queryParams}`, {
        ...GetHeaders,
      }).then(async res => {
        if (res.ok) {
          return res.json()
        }
        const error = await res.json()
        throw error
      }).then(data => {
        if (data && data.code == 200) {
          dispatch(UpdateLocation(data.data))
          return
        }
        throw data
      }).catch(setError).finally(() => {
        setLoader(false)
      })
    }
  }, [makeCall])

  return { data: selector, error, loader, get }
}

export const useAgendaList = ({ getInitial = false, sort = false, preventRedux = false, resBody = {} }) => {
  const selector = useSelector(state => state.lists.agendaList);
  const dispatch = useDispatch()
  const [body, setBody] = useState(resBody)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)
  const [loader, setLoader] = useState(false)
  const [makeCall, setMakeCall] = useState(getInitial)
  const get = useCallback((body) => {
    body && setBody(body)
    setMakeCall(true)
  }, [])

  useEffect(() => {
    if (makeCall && body) {
      setLoader(true)
      setMakeCall(false)
      const queryParams = new URLSearchParams({ logged_user_id: GetLoggedUserUUID(), medical_center_id: GetMediCenterId(), owner_of_logged_mc_id: GetOwnerOfLoggedMcUUID(), ...body });
      AppFetch(`${BaseUrl.endpoint}/agenda/list?${queryParams}`, {
        ...GetHeaders,
      }).then(async res => {
        if (res.ok) {
          return res.json()
        }
        const error = await res.json()
        throw error
      }).then(data => {
        if (data && data.code == 200) {
          setData(data.data)
          if (!preventRedux) {
            dispatch(UpdateAgenda(data?.data?.filter?.(item => item.sharing_access != 1)))
          }
          return
        }
        throw data
      }).catch(setError).finally(() => {
        setLoader(false)
      })
    }
  }, [makeCall, body])
  return { data: sort ? (preventRedux ? data : selector)?.sort?.((a, b) => a?.agenda_nom?.localeCompare?.(b?.agenda_nom)) : (preventRedux ? data : selector), error, loader, get }
}

export const useLocationAgendaList = ({ getInitial = false, resBody = {} }) => {
  const selector = useSelector(state => state.lists.locationAgendaList);
  const dispatch = useDispatch()
  const [body, setBody] = useState(resBody)
  const [error, setError] = useState(null)
  const [loader, setLoader] = useState(false)
  const [makeCall, setMakeCall] = useState(getInitial)
  const get = useCallback((body) => {
    body && setBody(body)
    setMakeCall(true)
  }, [])

  useEffect(() => {
    if (makeCall && body) {
      setLoader(true)
      setMakeCall(false)
      AppFetch(`${BaseUrl.endpoint}/agenda/location/list`, {
        ...GetHeaders,
      }).then(async res => {
        if (res.ok) {
          return res.json()
        }
        const error = await res.json()
        throw error
      }).then(data => {
        if (data && data.code == 200) {
          // setData(data.data)
          dispatch(UpdateLocationAgenda(data.data))
          return
        }
        throw data
      }).catch(setError).finally(() => {
        setLoader(false)
      })
    }
  }, [makeCall, body])
  return { data: selector, error, loader, get }
}


export const useLocationInsert = () => {
  const [loader, setLoader] = useState(false)
  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/location/insert`, {
        // ...PostHeaders,
        method: 'POST',
        body: body instanceof FormData ? (() => {
          body.append('created_by', GetLoggedUserUUID())
          body.append('logged_user_id', GetLoggedUserUUID())
          return body
        })() : JSON.stringify({
          ...body,
          created_by: GetLoggedUserUUID(), logged_user_id: GetLoggedUserUUID()
        })
      });
      setLoader(false)
      const res = await apiCall.json();
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        showError(res.message);
        reject(res);
      }
    });
  return { post, loader };
};

export const useLocationDelete = () => {
  const dispatch = useDispatch()
  const post = body =>
    new Promise(async (resolve, reject) => {
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/location/delete/${body.location_id}`, {
        ...PostHeaders
      });
      const res = await apiCall.json();
      if (apiCall.ok) {
        resolve(res.data);
        dispatch(DeleteLocation(body.location_id))
      } else {
        if (res?.code?.toString() == '409') {
          showError(i18n.t("api_err_location_cant_delete"), false);
        } else {
          showError(res.message);
        }
        resolve(res);
      }
    });
  return { post };
};

export const useLocationModify = () => {
  const post = body =>
    new Promise(async (resolve, reject) => {
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/location/update/${body instanceof FormData ? body.get('location_id') : body.location_id}`, {
        method: 'POST',
        body: body instanceof FormData ? (() => {
          body.append('created_by', GetLoggedUserUUID())
          body.append('logged_user_id', GetLoggedUserUUID())
          return body
        })() : JSON.stringify({
          ...body,
          created_by: GetLoggedUserUUID(), logged_user_id: GetLoggedUserUUID()
        })
      });
      const res = await apiCall.json();
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        showError(res.message);
        reject(res);
      }
    });
  return { post };
};

export const useDoctorLocationList = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const prams = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/location/doctor/list?${prams}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              setData(data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const useMedicalCenterInfoApi = ({ getInitial = false, startPoint = 'medicine', resBody = {} }) => {
  const [data, setData] = useState()
  const [body, setBody] = useState(resBody)
  const [startPath, setStartPath] = useState(startPoint)
  const [error, setError] = useState(null)
  const [loader, setLoader] = useState(false)
  const [makeCall, setMakeCall] = useState(getInitial)
  const get = useCallback((start, body) => {
    setData(null)
    body && setBody(body)
    start && setStartPath(start)
    setMakeCall(true)
  }, [])

  useEffect(() => {
    if (makeCall && body) {
      setLoader(true)
      setMakeCall(false)
      AppFetch(`${BaseUrl.endpoint}/${startPath}/profile/info${body}`, {
        ...GetHeaders,
      }).then(async res => {
        if (res.ok) {
          return res.json()
        }
        const error = await res.json()
        throw error
      }).then(data => {
        if (data && data.code == 200) {
          setData(data.data)
          return
        }
        throw data
      }).catch(setError).finally(() => {
        setLoader(false)
      })
    }
  }, [makeCall, body])
  return { data, error, loader, get }
}

export const useDeleteAgenda = () => {
  const selector = useSelector(state => state.lists.locationAgendaList);
  const dispatch = useDispatch();
  const post = (id, body) =>
    new Promise(async (resolve, reject) => {

      const apiCall = await AppFetch(`${BaseUrl.endpoint}/agenda/delete/${id}`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body
        })
      });
      const res = await apiCall.json();
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        if (res?.code?.toString() == '409') {
          showError(i18n.t("api_err_category_cant_delete"), false);
        } else {
          showError(res.message)
        }
        resolve("");
      }
    });
  return { post };
};

export const useUpdateAgenda = () => {
  const post = (body) =>
    new Promise(async (resolve, reject) => {
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/agenda/update/${body?.id}`, {
        ...PostHeaders,
        body: JSON.stringify({
          "medical_center_id": GetMediCenterId(), created_by: GetLoggedUserUUID(),
          ...body,
        })
      });
      const res = await apiCall.json();
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        showError(res.message)
        reject("");
      }
    });
  return { post };
};

export const useLocationImageDelete = () => {
  const post = (body) =>
    new Promise(async (resolve, reject) => {
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/location_img/delete/${body?.id}`, {
        ...PostHeaders
      });
      const res = await apiCall.json();
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        showError(res.message)
        reject("");
      }
    });
  return { post };
};

export const useLocationInfoList = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/location/based/list?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              setData(data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const useAgendaServiceList = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/agenda_service/details?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              setData(data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};
export const useAgendaDeplacer = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/agenda_deplacer/list?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              setData(data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const useLocationBasedDoctor = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/doctor/location_based/list?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              setData(data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const useReseachDoctorSearchList = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(JSON.parse(JSON.stringify(body)));
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams(JSON.parse(JSON.stringify({ ...body })))
        AppFetch(
          `${BaseUrl.endpoint}/search/list?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              setData(data?.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const useRelationPatientInsert = () => {
  const [loader, setLoader] = useState(false)
  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/creer-patient-reference`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
          'refered_user_id': GetLoggedUserUUID(),
          'logged_user_id': GetLoggedUserUUID(),
          'owner_of_logged_mc_id': null,
          "logged_med_center_id": null,
          'form_type': 1,
          'logged_user_type': GetCurrentUserTypeInt()
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        if (res?.errors && typeof res?.errors == 'object') {
          showError(res?.errors?.[Object.keys(res?.errors)?.[0]], false)
        } else {
          showError(res.message);
        }
        reject(res);
      }
    });
  return { post, loader };
};

export const useRelationPatientList = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/list-patient-reference?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              setData(data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};


export const useDoctorBasedSpeciality = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/doctor_based/speciality?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              setData(data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const useMedicalCenterUserListBasedLocation = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/medical_center/users/list?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              let sortedData
              if (data.data?.length) {
                sortedData = data.data.sort((a, b) => {
                  if (a.doctor_name < b.name) return -1
                  if (a.doctor_name > b.doctor_name) return 1
                  return 0
                })
              }
              setData(data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const useShareAccessInsert = () => {
  const [loader, setLoader] = useState(false)
  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/sharing/insert`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
          logged_user_id: GetLoggedUserUUID()
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        showError(res.message);
        reject(res);
      }
    });
  return { post, loader };
};


export const useAgendaDetails = ({ getInitial = false, resBody = {} }) => {
  const selector = useSelector(state => state.createAgenda);
  const dispatch = useDispatch()
  const [body, setBody] = useState(resBody);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body, medical_center_id: GetMediCenterId() })
        AppFetch(
          `${BaseUrl.endpoint}/agenda_details/show?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              dispatch(UpdateCreateAgenda({
                step: selector.step,
                ...data.data,
                service:
                  { speciality: data?.data?.agenda?.speciality/*?.split(",")?.map(value => ({ speciality_id: value }))*/ }
              }))
              return;
            }
            throw data;
          })
          .catch((err) => {
            showError(err.message)
            setError(err)
          })
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data: selector, error, loader, get };
};

export const useWeekOpenings = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/week_openings/doctor?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              setData(data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

function downloadBlobAsFile(blob, fileName) {
  var a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
}

export const useDownload = () => {
  const get = (url) => {
    GlobalLoaderActivate()
    AppFetch(url, { ...GetHeaders }).then((res) => res.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob)
        // downloadBlobAsFile(blob, mainUrl.pathname.split("/").reverse()[0])
        GlobalLoaderActivate(false)
        FileViewer({ filePath: url, fileType: 'pdf' })
      }).catch((err) => {
        GlobalLoaderActivate(false)
        showError(err.message)
      })
  }
  return { get };
};

export const useGetOpeningServices = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/ouverture/service/list?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              setData(data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const usePatientEarlyAppointment = () => {
  const [loader, setLoader] = useState(false)
  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/appointment/early`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        showError(res.message);
        reject(res);
      }
    });
  return { post, loader };
};

export const useAppointmentDelay = () => {
  const [loader, setLoader] = useState(false)
  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/appointment/patient_delay`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        if (res?.code == 1) {
          showError(i18n.t('retard_not_accepte'), false);
        } else {
          showError(i18n.t('retard_exceed'), false)
        }
        reject(res);
      }
    });
  return { post, loader };
};

export const useAgendaOuverture = () => {
  const [loader, setLoader] = useState(false)
  const dispatch = useDispatch()
  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/agenda_ouverture`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        dispatch(UpdateCreateAgenda({ step: '04', agenda_ouverture: res.data.details }))
        resolve(res.data);
      } else {
        showError(res.message);
        reject(res);
      }
    });
  return { post, loader };
}

export const useCalendarDisplaySettings = () => {
  const [loader, setLoader] = useState(false)
  const dispatch = useDispatch()
  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/display/settings`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        const payload = {
          ...res.data,
          start_time: res.data?.start_time?.toString?.() ? res.data?.start_time : 8,
          end_time: res.data?.end_time?.toString?.() ? res.data?.end_time : 20,
          calendar_days: res.data?.calendar_days ? res.data?.calendar_days?.split(',') : [0, 1, 2, 3, 4],
          //  agendaGroup: res.data?.agenda_group ? agendaGroup[res.data?.agenda_group - 1] : agendaGroup[0]
        }
        dispatch(UpdateConfigSettings(payload))
        resolve(res.data);
      } else {
        showError(res.message);
        reject(res);
      }
    });
  return { post, loader };
}

export const useGetCalendarDisplaySettings = ({ getInitial = true, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const dispatch = useDispatch()
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);
  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const formBody = objectToFormData(body)
        AppFetch(
          `${BaseUrl.endpoint}/display/settings/list`,
          {
            method: 'POST',
            body: formBody
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data.data) {
              const masterDisplay = data.data.reduce(
                (acc, curr) => {
                  acc.start_time = Math.min(acc.start_time, curr.start_time);
                  acc.end_time = Math.max(acc.end_time, curr.end_time);

                  const daysArray = curr.calendar_days?.split(',').map(Number) || [];
                  acc.calendar_days = [...new Set([...acc.calendar_days, ...daysArray])];

                  return acc;
                },
                {
                  start_time: 23, // highest allowed start_time → ensures reduction picks the smallest correct value
                  end_time: 1,    // lowest allowed end_time → ensures reduction picks the largest correct value
                  calendar_days: []
                }
              );

              const payload = {
                ...masterDisplay,
                start_time: typeof masterDisplay?.start_time == 'number' && masterDisplay?.start_time <= 23 ? masterDisplay?.start_time : 8,
                end_time: typeof masterDisplay?.end_time == 'number' ? masterDisplay?.end_time : 20,
                calendar_days: masterDisplay?.calendar_days.length > 0 ? masterDisplay?.calendar_days : [0, 1, 2, 3, 4, 5],
                //  agendaGroup: data.data?.agenda_group ? agendaGroup[data.data?.agenda_group - 1] : agendaGroup[0],
              }
              dispatch(UpdateConfigSettings(payload))
              setData(masterDisplay);
              return;
            }
            throw data;
          })
          .catch((e) => {
            console.log('payload config settings error', e)
          })
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, loader, get };
};

export const useLanguageList = ({ getInitial = false }) => {
  const [data, setData] = useState(null)
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(() => {
    setMakeCall(true);
  }, []);
  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);

        AppFetch(`${BaseUrl.endpoint}/languages/list`, {
          ...GetHeaders
        })
          .then(async res => {
            const response = await res.json();
            if (res.ok) {
              return response;
            } else {
              throw response;
            }
          })
          .then(data => {
            if (data) {
              setData([...data.data]);
            }
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall]
  );

  return { data, error, loader, get };
};


export const useAgendaPrintList = () => {
  const [loader, setLoader] = useState(false)
  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const params = new URLSearchParams({ ...body })
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/agenda/filter?${params}`, {
        ...GetHeaders
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        showError(res.message);
        reject(res);
      }
    });
  return { post, loader };
}


export const useTeleCallDetails = ({ getInitial = false, resBody = undefined }) => {
  const [body, setBody] = useState(resBody);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const [data, setData] = useState(null);


  const get = body => new Promise(async (resolve, reject) => {
    setLoader(true)
    const apiCall = await AppFetch(`${BaseUrl.endpoint}/tele-secretary/call-info${body}`, {
      ...GetHeaders
    })

    const res = await apiCall.json();
    if (apiCall.ok) {
      resolve(res.data)
      setLoader(false)
    } else {
      //  showError(res.message);
      reject(res);
      setLoader(false)
    }
  })



  return { data, error, loader, get };
};


export const useAppointmentReschedule = () => {
  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/rdv_reschedule/confirm`, {
        ...PostHeaders,
        body: JSON.stringify({
          action_by: GetCurrentUserTypeInt(),
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        showError(res.message);
        reject(res);
      }
    });
  return { post, loader };
}

export const useAgendaServiceTarif = () => {
  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/add-tarif`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        showError(res.message);
        reject(res);
      }
    });
  return { post, loader };
}


export const AgendaOpeningHours = (agenda_id) => {
  var data;
  const params = new URLSearchParams({
    agenda_id: agenda_id
  })

  data = AppFetch(`${BaseUrl.endpoint}/agenda/opening_hours?${params}`, { ...GetHeaders }).then(response => response.json()).then(data => {
    return data;
  });

  return data;
};

export const useGetServiceTariff = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/agenda/settings_tarif?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(res => {
            if (res) {
              setData({ ...res.data.data, patient: res.data.patient });
              return;
            }
            throw res;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const useCategoryServiceList = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/speciality/category_services?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(res => {
            if (res) {
              setData(res.data);
              return;
            }
            throw res;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const useSpecialityLocation = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/speciality/location?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(res => {
            if (res) {
              setData(res.data);
              return;
            }
            throw res;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const useAgendaSpecialityDelete = () => {
  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/agenda/speciality/delete`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      })
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res);
      } else {
        // showError(res.message)
        resolve(res);
      }
    });
  return { post, loader };
}

export const useAddSpeciality = () => {
  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/doctor/add/speciality`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        showError(res.message);
        reject(res);
      }
    });
  return { post, loader };
}

export const useHolidayEvents = () => {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear())
  const dispatch = useDispatch()
  const selector = useSelector(state => state.setting)

  const fetchHoliday = (year, startDate, endDate) => {
    if (year !== currentYear || (startDate != undefined && endDate != undefined)) {
      const sDate = startDate || `${year || currentYear}-01-01`
      const eDate = endDate || `${year || currentYear}-12-31`
      setCurrentYear(year)
      fetch(`https://openholidaysapi.org/PublicHolidays?countryIsoCode=FR&languageIsoCode=${(selector.lang || '')?.toLocaleUpperCase()}&validFrom=${sDate}&validTo=${eDate}`)
        .then((response) => response.json())
        .then((response) => {
          const map = response?.map?.(event => [event.startDate, {
            eventName: event.name[0].text,
            color: '#cfb0d6',
          }])
          dispatch(
            updateHolidayEvent({ holidays: map })
          )
        })
    }
  }

  return { fetchHoliday }
}

export const useStripeCreatePaymentIntent = () => {
  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/create_intent/11`, {
        ...PostHeaders,
        body: JSON.stringify({ items: [{ id: "xl-tshirt" }] })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res);
      } else {
        showError(res);
        reject(res);
      }
    });
  return { post, loader };
}

export const useAppointmentReConfirm = () => {
  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/appointment/reconfirm`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        showError(res.message);
        reject(res);
      }
    });
  return { post, loader };
}

export const useLocationGalleryList = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/location/gallery?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(res => {
            if (res) {
              setData(res.data);
              return;
            }
            throw res;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};


export const useVerifyPhoneNumber = () => {
  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/verify_phone`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        if (res.data?.data?.code == 400) {
          showError(i18n.t('invalid_phone_number'), false)
        } else {
          if (res?.data?.data?.type == "invalid_phone_number" || res?.data?.[0]?.errcode == 2009 || res?.data?.[0]?.errcode == 2001) {
            showError(i18n.t('invalid_phone_number'), false)
          } else {
            showError(res.message);
          }
          reject(res);
        }
      }
    });
  return { post, loader };
}

export const useVerifyCode = () => {
  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/verify_code`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        showError(res.message);
        reject(res);
      }
    });
  return { post, loader };
}

export const useOtpResend = () => {
  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/resend_code`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        showError(res.message);
        reject(res);
      }
    });
  return { post, loader };
}

export const useServicePrescriptionFile = ({ getInitial = true, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/service/prescription/list?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(res => {
            if (res) {
              setData(res.data);
              return;
            }
            throw res;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const useAgendaServiceRemove = () => {
  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/tarif/delete`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        reject(res);
      }
    });
  return { post, loader };
}


export const useAgendaAvailability = ({
  getInitial = false,
  resBody = {},
  preventRedux = false
}) => {
  const selector = useSelector(state => state.createAgenda);
  const [data, setData] = useState(null)
  const dispatch = useDispatch();
  const [body, setBody] = useState(resBody);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);

  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);


  useEffect(
    () => {
      if (makeCall) {
        setData(null)
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/availability/show?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(responseData => {
            if (responseData) {
              !preventRedux && dispatch(UpdateCreateAgenda({
                availability: responseData.data,
                agenda_setting: {
                  ...selector?.agenda_setting,
                  service_reserv: [...new Map(responseData.data?.flatMap?.(avail => avail.service)?.map?.(avail => [avail?.id, { ...avail, reservation: (avail?.reservation || '1,2,3') }])).values()]
                }
              }));
              setData(responseData.data)
              return;
            }
            throw responseData;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data: preventRedux ? data : selector?.availability, error, loader, get, body };
};

export const useCountryCodeList = ({ getInitial = true, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/countries/list?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(res => {
            if (res) {
              setData(res.data);
              return;
            }
            throw res;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const useDoctorAppointmentPrice = () => {
  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/doctor_patient_price`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        reject(res);
      }
    });
  return { post, loader };
}

export const useAbsenceInsert = () => {
  const [loader, setLoader] = useState(false)
  const dispatch = useDispatch()

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/absence/insert`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
        dispatch(DidAddAbsence(true))
      } else {
        reject(res);
      }
    });
  return { post, loader };
}

export const AbsenceListData = ({ resBody = {} }) => {
  var data;
  const params = new URLSearchParams({ ...resBody })
  data = AppFetch(`${BaseUrl.endpoint}/absence/list?${params}`,
    {
      ...GetHeaders
    })
    .catch(error => console.log(error))
    .then(response =>
      response.json()
    ).then(result => {
      if (result?.code != 200) return []
      return result?.data;
    });

  return data;
};

export const usePatientBlock = () => {
  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/block_patient`, {
        ...PostHeaders,
        body: JSON.stringify({
          medical_center_id: GetMediCenterId(),
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
        showSuccess(res.message);
      } else {
        reject(res);
        showError(res.message);
      }
    });
  return { post, loader };
}

export const useAbsenceEdit = () => {
  const [loader, setLoader] = useState(false)
  const dispatch = useDispatch()
  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/absence/update`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
        dispatch(DidAddAbsence(true))
      } else {
        if (res?.code == 6666) {
          showError(i18n.t('absence_edit_error'), false)
        } else {
          showError(res.message)
        }
        reject(res);
      }
    });
  return { post, loader };
}

export const useAbsenceDelete = () => {
  const [loader, setLoader] = useState(false)
  const dispatch = useDispatch()

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/absence/delete`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
        dispatch(DidAddAbsence(true))
      } else {
        reject(res);
      }
    });
  return { post, loader };
}

export const usePatientDetails = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const prams = new URLSearchParams({ type: 5, ...body })
        AppFetch(
          `${BaseUrl.endpoint}/user/profile?${prams}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              setData(data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};
export const usePatientAptHistory = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/patient/rdv/list?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              setData(data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const usePatientFutureRDV = () => {
  const [loader, setLoader] = useState(false)
  const get = body => new Promise(async (resolve, reject) => {
    setLoader(true)
    const params = new URLSearchParams({ ...body })
    const apiCall = await AppFetch(`${BaseUrl.endpoint}/future_rdv/check?${params}`, { ...GetHeaders })
    const res = await apiCall.json();
    if (apiCall.ok) {
      resolve(res.data)
      setLoader(false)
    } else {
      showError(res.message);
      reject(res);
      setLoader(false)
    }
  })

  return { get, loader }
}

export const useAptMarkColor = () => {
  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/appointment/mark-color`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        if (res?.data?.[0]?.errcode == 400) {
          showError(res?.data?.[0].message, false);
        }
        reject(res);
      }
    });
  return { post, loader };
}

export const useMessageToPatientInsert = () => {
  const [loader, setLoader] = useState(false)
  const dispatch = useDispatch()

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/RDVSendMessage/store-sendmessage`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
        dispatch(DidAddAbsence(true))
      } else {
        reject(res);
      }
    });
  return { post, loader };
}

export const useMessageToPatientEdit = () => {
  const [loader, setLoader] = useState(false)
  const dispatch = useDispatch()

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/RDVSendMessage/update-sendmessage`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
        dispatch(DidAddAbsence(true))
      } else {
        reject(res);
      }
    });
  return { post, loader };
}

export const useMessageToPatientDelete = () => {
  const [loader, setLoader] = useState(false)
  const dispatch = useDispatch()

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/RDVSendMessage/delete-sendmessage`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
        dispatch(DidAddAbsence(true))
      } else {
        reject(res);
      }
    });
  return { post, loader };
}

export const useMessageToPatientList = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}/RDVSendMessage/listing-sendmessage?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              setData(data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};


export const getMessageToPatientList = ({ resBody = {} }) => {
  var data;
  const params = new URLSearchParams({ ...resBody })

  data = AppFetch(`${BaseUrl.endpoint}/RDVSendMessage/listing-sendmessage?${params}`, { ...GetHeaders })
    .then(response => response.json())
    .then(data => {
      return data;
    });

  return data;
};


export const usePatientAptReferant = ({ getInitial = false, resBody = {} }) => {
  const [body, setBody] = useState(resBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body, medical_center_id: GetMediCenterId() })
        AppFetch(
          `${BaseUrl.endpoint}/appointment/patient-last-referent?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              setData(data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const useCreateOrishaPatient = () => {
  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/create_patient_via_orisha`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        reject(res);
      }
    });
  return { post, loader };
}

export const useInitiatePayment = () => {
  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await AppFetch(`${BaseUrl.endpoint}/create_facture_via_orisha`, {
        ...PostHeaders,
        body: JSON.stringify({
          ...body,
        })
      });
      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res.data);
      } else {
        reject(res);
      }
    });
  return { post, loader };
}

export const useAppGet = ({ endpoint, reqBody = {}, getInitial = false, interprocess }) => {
  const [body, setBody] = useState(reqBody);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [makeCall, setMakeCall] = useState(getInitial);
  const get = useCallback(body => {
    body && setBody(body);
    setMakeCall(true);
  }, []);

  useEffect(
    () => {
      if (makeCall) {
        setLoader(true);
        setMakeCall(false);
        const params = new URLSearchParams({ ...body })
        AppFetch(
          `${BaseUrl.endpoint}${endpoint}?${params}`,
          {
            ...GetHeaders
          }
        )
          .then(async res => {
            if (res.ok) {
              return res.json();
            }
            const error = await res.json();
            throw error;
          })
          .then(data => {
            if (data) {
              setData(interprocess ? interprocess(data.data) : data.data);
              return;
            }
            throw data;
          })
          .catch(setError)
          .finally(() => {
            setLoader(false);
          });
      }
    },
    [makeCall, body]
  );

  return { data, error, loader, get };
};

export const useAppPost = ({ endpoint }) => {

  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      try {
        setLoader(true)
        const apiCall = await AppFetch(`${BaseUrl.endpoint}${endpoint}`, {
          ...PostHeaders,
          body: JSON.stringify({
            ...body,
          })
        });
        const res = await apiCall.json();
        if (apiCall.ok) {
          resolve(res.data);
        } else {
          reject(res);
        }
      } catch (error) {
        reject(error);
      } finally {
        setLoader(false)
      }
    });

  return { post, loader };

}

export const useIconopeeCityCode = () => {

  const [loader, setLoader] = useState(false)

  const post = body =>
    new Promise(async (resolve, reject) => {
      setLoader(true)
      const apiCall = await fetch(
        "https://localhost.icanopee.net:9982/api/hl_getCogCityCodes",
        {
          method: "POST",
          headers: {
            "accept": "application/json, text/javascript, */*; q=0.01",
            "content-type": "text/plain;charset=UTF-8"
          },
          body: JSON.stringify(body)
        }
      );

      const res = await apiCall.json();
      setLoader(false)
      if (apiCall.ok) {
        resolve(res);
      } else {
        reject(res);
      }
    });

  return { post, loader };
}

export const getAgendaNotesList = ({ resBody = {} }) => {
  var data;
  const params = new URLSearchParams({ ...resBody })

  data = AppFetch(`${BaseUrl.endpoint}/agenda/notes/list?${params}`, { ...GetHeaders })
    .then(response => response.json())
    .then(data => {
      return data;
    });

  return data;
};

export const usePromiseGet = ({ endpoint }) => {
  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const get = useCallback(async (newBody) => {
    const apiBody = newBody || body;
    setBody(apiBody);
    const params = new URLSearchParams({
      ...(apiBody?.reqBody ? JSON.parse(JSON.stringify(apiBody?.reqBody)) : {})
    });

    setLoader(true);

    try {
      const response = await AppFetch(
        `${BaseUrl.endpoint}${endpoint}?${params}`,
        { ...GetHeaders }
      );

      if (!response.ok) {
        const error = await response.json();
        throw error;
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error?.response?.data || error;
    } finally {
      setLoader(false);
    }
  }, [body]);

  return { get, loader };
};